<template>
    <div class="float-left mr-1">
        <span class="text-danger">
            <i
                class="fa fa-trash fa-lg icon-button"
                title="Excluir Alerta"
                @click.stop="confirmarExcluir()"
            ></i>
        </span>
    </div>
</template>

<script>
import AlertasServicos from './AlertasServicos'

export default {
    props: {
        idContrato: {
            type: String
        },

        alerta: {
            type: Object,
            default: () => ({})
        }
    },

    data() {
        return {}
    },

    methods: {
        confirmarExcluir() {
            this.$swal({
                title: 'Alerta',
                html: 'Confirma a exclusão do alerta?',
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Sim',
                cancelButtonText: 'Não'
            }).then((result) => {
                if (result.value) {
                    this.excluir()
                }
            })
        },

        excluir() {
            this.$store.dispatch('addRequest')
            let alertasDto = {
                idContrato: this.idContrato,
                alertaId: this.alerta.alertaId
            }
            AlertasServicos.excluirAlerta(alertasDto).then((response) => {
                if (response.success) {
                    this.registroSalvoComSucesso()
                } else {
                    this.erros = response.errors
                }
                this.$store.dispatch('removeRequest')
            })
        },

        registroSalvoComSucesso() {
            this.$toast.success(
                'Registro excluído com sucesso!',
                'OK',
                this.$toastConfig.success
            )
            this.$emit('obterAlertasAtualizados')
        }
    },

     created() {},

     computed: {},

     watch: {},

     validations: {}
}
</script>